export const RECAPTCHA_SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY
export const RECAPTCHA_SITE_KEY_CYPRESS = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' // test credentials
export const LOCAL_STORAGE_CHANNEL_ID_KEY = 'ppVisitSessionChannelId'
export const LOCAL_STORAGE_CHANNEL_LAST_ACTIVE = 'ppVisitSessionLastActive'
export const LOCAL_STORAGE_CHANNEL_PRACTICE_UUID = 'ppVisitSessionPracticeUuid'
export const APPOINTMENT_TYPE_DROP_IN = 'drop-in'
export const APPOINTMENT_TYPE_SCHEDULED = 'scheduled'
